import { ReactSelectOption } from '@texas/types';
import { GroupBase, components, InputProps } from 'react-select';

export function InputComponent<IsMulti extends boolean>(
  props: InputProps<ReactSelectOption, IsMulti, GroupBase<ReactSelectOption>>,
) {
  return <components.Input {...props} isHidden={false} />;
}
